// extracted by mini-css-extract-plugin
export default {"controls":"NowPlayingCardControls_controls__lG1q2"};